import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const Ctx = createContext(null);
export const useApp = () => useContext(Ctx);

export const hasDataAccess = (u) =>
  !!u && u !== false && (["admin", "md"].includes(u.role) || (u.department === "sales" && ["vp", "zonal", "manager"].includes(u.role)));

const DEFAULTS = { brand: "KIA", basis: "total", period: "mtd", district: "", territoryOnly: false };

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [meta, setMeta] = useState(null);
  const [filters, setFiltersState] = useState(() => {
    try {
      return { ...DEFAULTS, ...JSON.parse(localStorage.getItem("msip_filters") || "{}"), basis: "total" };
    } catch {
      return DEFAULTS;
    }
  });

  const setFilters = (patch) =>
    setFiltersState((f) => {
      const n = { ...f, ...patch };
      localStorage.setItem("msip_filters", JSON.stringify(n));
      return n;
    });

  const refreshMeta = useCallback(async () => {
    try {
      const { data } = await api.get("/meta");
      setMeta(data);
    } catch (e) {
      /* not authed yet */
    }
  }, []);

  useEffect(() => {
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false));
  }, []);

  useEffect(() => {
    if (hasDataAccess(user)) refreshMeta();
  }, [user, refreshMeta]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    sessionStorage.removeItem("sov-a-mode");
    setUser(data);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return <Ctx.Provider value={{ user, setUser, login, logout, meta, refreshMeta, filters, setFilters }}>{children}</Ctx.Provider>;
}
